import { render, staticRenderFns } from "./ParapharmacyProductItemInfo.vue?vue&type=template&id=82abfb72"
import script from "./ParapharmacyProductItemInfo.vue?vue&type=script&lang=js"
export * from "./ParapharmacyProductItemInfo.vue?vue&type=script&lang=js"
import style0 from "./ParapharmacyProductItemInfo.vue?vue&type=style&index=0&id=82abfb72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports